import { useMutation } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'
import { BupError } from '@BUP/lib/errors'
import { monitorException } from '@BUP/services/monitor'
import { enrichError } from '@BUP/services/monitor/enrichError'
import { reportErrorOnce } from '@BUP/services/monitor/reportErrorOnce'

const saveResponses = async ({ enrollmentId, surveyId, responses }) => {
  const client = await getApi('sociogram', { authenticated: true })

  const promises = responses.map(response =>
    client.post('/responses', {
      surveyId,
      enrollmentId,
      question_id: response?.question?.id,
      answerId: response?.id,
      response_content: response?.content?.length > 0
        ? response?.content?.map(elem => ({
          enrrollmentId: elem.enrollmentId,
          courses: elem.courses
        }))
        : []
    })
  )

  const results = await Promise.all(promises)

  const normalizedResults = results.map(result => {
    if (result.status === 204) {
      return { id: null, success: true }
    }
    return result.data
  })

  if (
    responses.find(response => response.question.isRequired) &&
    normalizedResults.length === 0
  ) {
    throw new BupError({ code: 'api/required-response-not-sended' })
  }

  if (normalizedResults.length !== responses.length) {
    throw new BupError({ code: 'api/results-responses-missmatch' })
  }

  if (!normalizedResults.every(r => r?.id || r?.success)) {
    throw new BupError({ code: 'api/missing-result-id' })
  }

  return normalizedResults
}

export const useCreateQuestionResponse = (enrollmentId, surveyId) => {
  return useMutation({
    mutationFn: (responses) => saveResponses({ enrollmentId, surveyId, responses }),
    onError: (error) => {
      reportErrorOnce(error, () => {
        const wrappedError = new Error('Error saving question responses', { cause: error })

        monitorException(wrappedError, {
          tags: { hook: 'useCreateQuestionResponse' },
          extra: { enrollmentId, surveyId, ...enrichError(error) }
        })
      })
    }
  })
}
